/**
 * Step 4: WhatsApp
 * Coleta o número de telefone/WhatsApp do usuário
 */

import React, { useState } from 'react';
import { StepContainer, FormFieldGroup, StepNavigation } from '../components';
import { StepProps, useFormContext } from '../context';
import { useFormValidation } from '../hooks';
import { validatePhone } from '../validators';

const Step4_Whatsapp: React.FC<StepProps> = ({ onNext, onPrevious, data, isLoading }) => {
  const { updateFields } = useFormContext();
  const [localData, setLocalData] = useState({ phone: data.phone || '' });
  const [errors, setErrors] = useState<Record<string, string>>({});

  const formatPhone = (value: string): string => {
    const cleaned = value.replace(/\D/g, '');
    const match = cleaned.match(/(\d{0,2})(\d{0,5})(\d{0,4})/);
    
    if (!match) return value;
    
    let formatted = '';
    if (match[1]) formatted = `(${match[1]}`;
    if (match[2]) formatted += `) ${match[2]}`;
    if (match[3]) formatted += `-${match[3]}`;
    
    return formatted;
  };

  const handleChange = (value: string) => {
    const formatted = formatPhone(value);
    setLocalData({ phone: formatted });
    setErrors({});
  };

  const handleNext = () => {
    const validation = validatePhone(localData.phone);
    
    if (!validation.valid) {
      setErrors({ phone: validation.error || 'Telefone inválido' });
      return;
    }
    // TODO: check phone uniqueness on pre registers and users table
    updateFields(localData);
    onNext(localData);
  };

  return (
    <StepContainer
      title="Qual seu WhatsApp?"
      description="Usaremos para entrar em contato"
    >
      <FormFieldGroup
        label="WhatsApp"
        error={errors.phone}
        required
      >
        <input
          type="tel"
          placeholder="(45) 98765-4321"
          value={localData.phone}
          onChange={(e) => handleChange(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-[#5c5c5c]"
        />
      </FormFieldGroup>

      <StepNavigation
        onNext={handleNext}
        onPrevious={onPrevious}
        isLoading={isLoading}
        showPrevious={true}
      />
    </StepContainer>
  );
};

export default Step4_Whatsapp;
